// js/custom-element/section/product/product-meta.js
var ProductMeta = class extends HTMLElement {

    #onVariant
    #form

    connectedCallback (){

        this.#form = document.getElementById
            ( this.getAttribute('form-id') )

        this.#onVariant = this
            ._onVariantChanged.bind(this)

        this.#form?.addEventListener
            ( 'Variant:Changed' , this.#onVariant )
    }

    disconnectedCallback (){
        this.#form?.removeEventListener('Variant:Changed',this.#onVariant)
    }

    async _onVariantChanged (){

        const { sectionId } = this.dataset

        const url = new URL(window.location)
        url.searchParams.set('section_id',sectionId)

        const response = await fetch(url)

        const html = await response.text()

        const parser = new DOMParser()

        const dom = parser.parseFromString(html,'text/html')


        const replace = ( selector ) => this
            .querySelector(selector)
            ?.replaceWith(dom.querySelector(selector))

        replace(`[ data-product-label-list ]`)
        replace(`[ data-product-price-list ]`)
        replace(`[ data-product-sku-container ]`)
    }
}


window.customElements.define("product-meta", ProductMeta);
